import script from "./PlacementLocationSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PlacementLocationSelect.vue?vue&type=script&setup=true&lang=js"

import "./PlacementLocationSelect.vue?vue&type=style&index=0&id=711c35c4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711c35c4"]])

export default __exports__